<template>
<div class="popup" v-cloak v-show="verificationShow">
     <div class="content" id="twoStepverification">
           <div class="title">
                 {{$t('language.twoStepverification.bind')}}
                 <div class="icon white-close dialog-close" @click="closePage()"></div>
           </div>
           <div class="step-body-content">
                <div style="float:left;height:60Px;">
                {{$t('language.twoStepverification.useAccount')}}
                </div>
                <div class="step-footer">
                     <button class="step-bind" @click="toBindEmail()">{{$t('language.popup.personalCenter.bindEmail')}}</button>
                     <button class="step-cancel" @click="cancelPage()">{{$t('language.twoStepverification.cancel')}}</button>
                </div>
           </div>
     </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            verificationShow:false
        }
    },
    methods: {
        closePage(){
            this.verificationShow=false;
        },
        cancelPage(){
            this.verificationShow=false;
        },
        toBindEmail(){
            this.$parent.$refs.bindEmailJumpDialog.bindEmailShow=true;
            this.verificationShow=false;

        }
    
   },

}

</script>

<style>
#twoStepverification{
    width: 500Px;
    height: 200Px;
}
.step-body-content{
    width: 100%;
    height: calc(100% - 40Px);
    box-sizing: border-box;
    padding: 30Px 30Px 10Px 30Px;
}
.step-footer{
   float: left;
   height: calc(100% - 60Px);
   width: 100%;
    display: flex;
  align-items: center; /*定义body的元素垂直居中*/
  justify-content: center; /*定义body的里的元素水平居中*/
}
.step-bind,.step-cancel{
    min-width: 110Px;
    
}
.step-bind{
    margin-right: 40Px;
}
.step-cancel,.step-cancel:hover{
    background: #fff;
    color: #5562b4;
    border: 1Px solid #b3bcf6;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/personal_center_popups/stepverification_bind_email_popup.vue